import { createRef } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Helmet } from 'react-helmet'
import { Loader, Tip } from '@vzmi/shp_shared_compo'
import { createI13nNode } from '@vzmi/ec-react-i13n'
import styles from './SearchKeywords.css'
import { sendI13nClickEvent } from '../../../lib/i13nUtil'
import safeAwait from '../../../lib/safeAwait'
import SPBaseModule from '../../lib/SPBaseModule'
import { withI13nWrapper } from '../Common/I13nWrapper'
import Section from '../Common/ItemPage/Section/Section'
import RangeSummary from '../Common/NewDashboard/RangeSummary/RangeSummary'
import TableAction from '../Common/NewDashboard/Table/TableAction/TableAction'
import Sort from '../Common/NewDashboard/Sort/Sort'
import CustomizeTip from '../Dashboard/OperatingDashboard/SearchKeywords/Tip/Tip'
import Table from '../Dashboard/OperatingDashboard/SearchKeywords/Table/Table'
import { SORT_OPTIONS } from '../Dashboard/OperatingDashboard/SearchKeywords/constants'
import {
  GA_CLICK_ACTION,
  getI13nModel
} from './SearchKeywords.ga'
import KeywordsListingDialog from '../Dashboard/OperatingDashboard/SearchKeywords/KeywordsListingDialog/KeywordsListingDialog'

const SEARCH_KEYWORDS_LIMIT = 20

class SearchKeywords extends SPBaseModule {
  constructor (props) {
    super(props)
    this.state = {
      sortType: SORT_OPTIONS[0].value,
      data: [],
      dateRange: []
    }
    this.dialog = createRef()
  }

  componentDidMount () {
    const { i13nMethods: { sendI13nPageViewByPageKey } } = this.props
    this.onSearch()
    sendI13nPageViewByPageKey('searchKeywords')
  }

  onSearch = () => this.loading(async () => {
    const { fetchSearchKeywords } = this.props.actions
    const { sortType } = this.state
    const params = {
      sort: `-${sortType}`,
      // dashboard 頁面一次只顯示前 20 筆
      limit: SEARCH_KEYWORDS_LIMIT
    }

    const [reqError, resp] = await safeAwait(fetchSearchKeywords(params))
    const error = reqError || resp.error
    if (error) {
      this.setIsError(true)
      this.setIsLoading(false)
      return
    }

    const {
      searchKeywords = [],
      reportDateStart,
      reportDateEnd
    } = _.get(resp, 'payload', {})
    const isReportDateExist = reportDateStart && reportDateEnd
    this.setState({
      data: searchKeywords,
      dateRange: isReportDateExist ? [reportDateStart, reportDateEnd] : []
    })
    this.setIsSuccess(true)
  })

  onSortChange = e => {
    const { sortType } = this.state
    const newSortType = _.get(e, 'target.value', '')
    if (newSortType === sortType) {
      return
    }
    this.sendPageview({
      type: GA_CLICK_ACTION.TABLE_SORT,
      payload: newSortType
    })
    this.setState(
      () => ({ sortType: newSortType }),
      () => this.onSearch()
    )
  }

  onListingClick = async (reasonId, reason) => this.dialog.current.loading(async () => {
    this.sendPageview({
      type: GA_CLICK_ACTION.VIEW_GD
    })
    this.dialog.current.onOpen(reasonId, reason)
  })

  sendPageview = (action) => {
    const { i13n } = this.props
    const i13nModel = getI13nModel(action)
    sendI13nClickEvent({ i13n, i13nModel })
  }

  render () {
    const {
      text: title
    } = this.props
    const {
      sortType,
      data,
      dateRange,
      isLoading,
      isError
    } = this.state

    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Section title={title}>
          <Loader loaded={!isLoading}>
            {
              isError
                ? this.renderIOError()
                : (
                  <>
                    <RangeSummary range={dateRange}>
                      （自 2026/01/13(含)起，改由 Google Analytics (GA) 提供。)
                    </RangeSummary>
                    <CustomizeTip />
                    <TableAction
                      className={styles.tableAction}
                      leftContent={(
                        <Tip
                          type='info'
                          className={styles.tips}
                        >
                          {`共 ${_.size(data)} 筆`}
                        </Tip>
                      )}
                    >
                      <Sort
                        id='search-keywords'
                        options={SORT_OPTIONS}
                        sortType={sortType}
                        onChange={this.onSortChange}
                      />
                    </TableAction>
                    <Table
                      data={data}
                      onListingClick={this.onListingClick}
                    />
                  </>
                )
            }
          </Loader>
        </Section>
        <KeywordsListingDialog
          key='dialog'
          ref={this.dialog}
          fetchSpecificSearchKeywordListings={this.props.actions.fetchSpecificSearchKeywordListings}
        />
      </>
    )
  }
}

const hoc = compose(
  withI13nWrapper,
  createI13nNode
)

export default hoc(SearchKeywords)
